import { normalizeScheduleCellCode } from "@/utils/shift-util";

/**
 * 발행 스냅샷 셀 배경색: `schedule[].color` 우선, 비면 `roster.shift_colors[code]` 등으로 폴백.
 */
export function getSnapshotCellDisplayColor(
  cell: unknown,
  shiftColors: Record<string, string>
): string {
  const code = normalizeScheduleCellCode(cell).trim();
  if (!code || code === "-") return "transparent";

  if (
    typeof cell === "object" &&
    cell !== null &&
    "color" in cell &&
    typeof (cell as { color: unknown }).color === "string"
  ) {
    const c = (cell as { color: string }).color.trim();
    if (c) return c;
  }

  if (shiftColors[code]) return shiftColors[code];
  const head = code.charAt(0);
  if (head && shiftColors[head]) return shiftColors[head];

  return "transparent";
}
